import { apiFetch } from "@core/index";
import { useMutation } from "@tanstack/react-query";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";

export const usePushTrigger = () => {
  return useMutation({
    mutationFn: async (config: { remarks?: string }) => {
      const payload = config.remarks ? { remarks: config.remarks } : {};

      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/trigger`, {
        method: "POST",
        body: payload,
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message || "", {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Push trigger executed successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to execute push trigger. Error: " + (error.message ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        },
      );
    },
  });
};
